import axios, { type AxiosInstance } from "axios";
import { useLanguageStore } from "../store/languageStore";
// Create Axios instances
const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


apiClient.interceptors.request.use((config:any) => {
  const store = useLanguageStore();
    config.headers = {
      ...config.headers,
      "Accept-Language": store.language.value,
    } as any;

  config.headers = {
    ...config.headers,
    "Accept-Language": store.language.value,
  } as any;

  return config;
});


export { apiClient };
